const DEFAULT_MAX = 400;
const DEFAULT_TTL_MS = 1000 * 60 * 5;

/**
 * Creates an in-memory LRU-ish cache with TTL expiry. Cache keys are opaque
 * strings composed by callers — typically `${namespace}::${collection}::${id}`
 * so multiple readers (one per database) don't collide.
 */
export function createEntityCache({ max = DEFAULT_MAX, ttlMs = DEFAULT_TTL_MS } = {}) {
    const store = new Map();

    function read(key) {
        const entry = store.get(key);
        if (!entry) return null;
        if (entry.expires < Date.now()) {
            store.delete(key);
            return null;
        }
        return entry.value;
    }

    function write(key, value) {
        store.set(key, { value, expires: Date.now() + ttlMs });
        if (store.size > max) {
            const oldestKey = store.keys().next().value;
            if (oldestKey) store.delete(oldestKey);
        }
    }

    function remove(key) {
        store.delete(key);
    }

    function clear() {
        store.clear();
    }

    function size() {
        return store.size;
    }

    return { read, write, remove, clear, size };
}

export function cacheKey(namespace, collection, id) {
    return `${namespace}::${collection}::${id}`;
}
